/*
 * @Author: libo 
 * @Date: 2020-11-13 17:04:54 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-08 12:31:42
 */

<template>
  <a-modal v-model="visible" 
    :title="title" 
    :width="width" 
    switchFullscreen 
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-tabs v-model="activeKey" @change="changeTab">
      <a-tab-pane key="1" :tab="$t('缴费')" >
        <div class="form-contain">
          <a-divider orientation="left">{{ $t('用户信息') }}</a-divider>
          <detail-list>
            <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
            <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
            <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
            <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
            <detail-list-item :term="$t('用户地址')">{{model.userAddr}}</detail-list-item>
            <detail-list-item :term="$t('用水单价(元)')">{{userByKeyId.userPriceTotal}}</detail-list-item>
            <detail-list-item :term="$t('价格名称')">{{userByKeyId.userPriceName}}</detail-list-item>
            <detail-list-item :term="$t('单次最大购买金额(元)')">{{userByKeyId.maxBuyOnce}}</detail-list-item>
            <detail-list-item :term="$t('最大囤积金额(元)')">{{userByKeyId.maxHording}}</detail-list-item>
            <detail-list-item :term="$t('用户余额(元)')">
              <a-tag color="cyan" style="font-size: 14px;padding: 5px">
                {{userByKeyId.userAccountNum}}
              </a-tag>
            </detail-list-item>
            <detail-list-item :term="$t('累计流量(m³)')">{{model.meterTotalUse}}</detail-list-item>
          </detail-list>
          <div>
            <a-divider orientation="left">{{ $t('用户缴费信息') }}</a-divider>
            <a-form-model ref="form" :model="form" :rules="rules" :colon="false">
              <a-row :gutter="16">
                <a-col :span="9">
                  <a-form-item class="a-form-model-item-row" :label="$t('订单编号')" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 0px">
                    <a-input v-model="userByKeyId.orderId" style="width: 100%;" :readOnly="true" class="background"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-button type="primary" :ghost="true" style="margin-top:5px;" @click="Refresh()">
                    {{ $t('刷新') }}
                  </a-button>
                </a-col>
              </a-row>
              <a-row :gutter="16">
                <a-col :span="8">
                  <a-form-model-item :label="$t('交易方式')" prop="payWay">
                    <a-radio-group  v-model="form.payWay">
                      <a-radio :value="1">
                        {{ $t('营业厅现金') }}
                      </a-radio>
                      <a-radio :value="2">
                        {{ $t('扫码支付') }}
                      </a-radio>
                      <a-radio :value="3">
                        {{ $t('对公转账') }}
                      </a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" >
                  <a-form-model-item :label="$t('计费类型')" prop="payType">
                    <a-radio-group v-model="form.payType" @change="handleChange">
                      <a-radio :value="2">
                        {{ $t('按吨数') }}
                      </a-radio>
                      <a-radio :value="1">
                        {{ $t('按金额') }}
                      </a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <!-- <a-col :span="8">
                  <a-form-model-item label="用户当前余额(元)">
                    <a-input v-model="userByKeyId.userAccountNum" :readOnly="true" class="background"></a-input>
                  </a-form-model-item>
                </a-col> -->
              </a-row>
              <a-row :gutter="16">
                <div v-if="thebillingtype==2">
                  <a-col :span="8" >
                    <a-form-model-item :label="$t('交易吨数(吨)')" prop="buyWaterCount">
                      <a-input v-model="form.buyWaterCount" @blur="buyWaterCount" :placeholder="$t('请输入交易吨数')"></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item label=" ">
                    <a-button v-for="item in itemList" :key="item.key" class="money-choose-btn"  @click="Capacity(item.value)" style="margin-right: 10px">
                    {{item.value}}t
                    </a-button>
                    </a-form-model-item>
                  </a-col>
                </div>
                <div v-if="thebillingtype==1">
                  <a-col :span="8" >
                    <a-form-model-item :label="$t('充值金额(元)')" required prop="userTotalPayNum">
                      <a-input v-model="form.userTotalPayNum" @blur="userTotalPayNum" :placeholder="$t('请输入充值金额')"></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item label=" ">
                    <a-button v-for="item in payList" :key="item.key" class="money-choose-btn" @click="amountofmoney(item.value)" style="margin-right: 10px">
                    ¥{{item.value}}
                    </a-button>
                    </a-form-model-item>
                  </a-col>
                </div>
                <a-col :span="8">
                  <a-form-model-item :label="$t('应收金额(元)')" prop="buyWaterMoney">
                    <!-- <a-input v-model="form.buyWaterMoney" :readOnly="true" class="background"></a-input> -->
                    <a-tag color="cyan" style="font-size: 16px;padding: 8px;font-weight: bold;">
                      {{form.buyWaterMoney}}
                    </a-tag>
                  </a-form-model-item>
                </a-col>
                <!-- <a-col :span="8">
                  <a-form-model-item label="交易吨数(m³)" prop="tradingTonnage">
                    <a-input v-model="form.tradingTonnage" :readOnly="true" class="background"></a-input>
                  </a-form-model-item>
                </a-col> -->
                <a-col :span="8" v-if="thebillingtype==2">
                  <a-form-model-item :label="$t('实际付款(元)')" prop="userRealPay">
                    <a-input v-model="form.userRealPay" :disabled="form.payWay != 1" @blur="userRealPay" :placeholder="$t('请输入实际付款金额')"></a-input>
                  </a-form-model-item>
                </a-col>

                <a-col :span="8" v-if="thebillingtype==2">
                  <a-form-model-item :label="$t('用户找零(元)')" prop="userReturn">
                    <a-input v-model="form.userReturn" :readOnly="true" class="background"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24">
                  <a-form-model-item :label="$t('缴费备注')" prop="remark">
                    <a-textarea v-model="form.remark" :placeholder="$t('请输入缴费备注')" />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row>
                <a-col :span="7"></a-col>
                <a-col :span="8">
                  <a-button type="danger" block size="large" @click="recharge()">
                    {{ $t('充值') }}
                  </a-button>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('充值记录')">
        <detail-list>
          <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
          <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
          <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
        </detail-list>
        <div class="form-contain">
          <a-table
          :columns="columns"
          :data-source="data"
          rowKey='id'
          size='middle'
          :scroll="{ x: true }"
          :pagination="ipagination"
          @change="handleTableChange"
          class="j-table-force-nowrap"
          >
            <span slot="userPriceSlot" slot-scope="text, record">
              <span v-if="record.userPriceName"> {{record.userPriceName}}({{record.userPriceTotal?record.userPriceTotal + $t('元'): '--'}})</span>
              <span v-else>--</span>
            </span>
          </a-table>
        </div>
      </a-tab-pane>
    </a-tabs>
    <print-pay-note-modal ref="printPayNoteModal"></print-pay-note-modal>
  </a-modal>
</template>

<script>
  import { getAction,putAction } from '@/api/manage'
  import {isUndefined} from'@/utils/validate'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import printPayNoteModal from './printPayNoteModal'
  import {payWayObj,payTypeObj} from '@/utils/constants/commonConstant'

  const data = [];
  export default {
    name: 'MeterPayForm',
    components: {
      DetailList,
      DetailListItem,
      printPayNoteModal
    },
    props: {
    },
    data () {
      return {
        width:1100,
        visible: false,
        data,
        activeKey:'1',
        userByKeyId:{},
        model: {},
        form:{
          payType:2,
          payWay:1,
          buyWaterCount:'',
          userTotalPayNum:'',
          buyWaterMoney:'',
          userRealPay:'',
          remark:'',
          userReturn:'',
        },
        confirmLoading: false,
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        payList:[   //定义paylist列表
          {key:1, value:100 },
          {key:2, value:200},
          {key:3, value:500}
        ],
        itemList:[  //定义itemlist列表
          {key:1, value:10},
          {key:2, value:50},
          {key:3, value:100}
        ],
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          doPayTask:"/jeecg-charge/meter/userPay/doPayTask",
          userByKeyId:"/jeecg-charge/meter/userPay/queryUserByKeyId",  //缴费前查询接口
          UserRecordList:"/jeecg-charge/meter/meterUserPayRecord/list", //缴费记录查询接口
        },
        thebillingtype: 2,
        realpay:0,
      }
    },
    computed: {
      title() {
        return this.$t('充值')
      },
      columns() {
        return [
        /*{
          title: '用户姓名',
          dataIndex: 'userName',
          align:'center'
        },*/{
          title: this.$t('购买金额(元)'),
          dataIndex: 'userPayAccountNum',
          align:'center'
        },{
          title: this.$t('缴费途径'),
          dataIndex: 'payWay',
          align:'center',
          customRender:(t,r,index) => {
            if(isUndefined(payWayObj[t])) {
              return this.$t("其他")
            }
            return this.$t(payWayObj[t])
          }
        },{
          title: this.$t('价格信息'),
          dataIndex: 'userPrice',
          align:'center',
          scopedSlots: { customRender: 'userPriceSlot' },
        },{
          title: this.$t('购买量(吨)'),
          dataIndex: 'payWaterNum',
          align:'center'
        },{
          title: this.$t('订单号'),
          dataIndex: 'payOrderId',
          align:'center'
        },{
          title: this.$t('操作员'),
          dataIndex: 'createBy',
          align:'center'
        },{
          title: this.$t('充值日期'),
          dataIndex: 'createTime',
          align:'center'
        },{
            title: this.$t('剩余金额(元)'),
            dataIndex: 'userNowAccountNum',
            align: 'center'
          },{
            title: this.$t('备注'),
            dataIndex: 'payRemark',
            align:'center'
          },{
          title: this.$t('操作类型'),
          dataIndex:'userAccountPayType',
          align:'center',
          fixed:"right",
          width: 70,
          customRender:(t,r,index) => {
            if(isUndefined(payTypeObj[t])) {
              return this.$t("其他")
            }
            return this.$t(payTypeObj[t])
          }
        },
        ]
      },
      rules() {
        return {
          buyWaterCount:[
            { required: true, message: this.$t('请输入交易吨数')},
            { required: false,pattern: /^[1-9]\d*$/,message: this.$t('交易吨数输入有误，请重新输入')}
            ], //交易吨数
          userTotalPayNum:[
            { required:true, message: this.$t('请输入充值金额')},
            {required: false,pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,message: this.$t('充值金额输入有误，请重新输入')}
          ], //充值金额
          userRealPay:[
            {required:true, message:this.$t('请输入实际付款金额')},
            {required: false,pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,message: this.$t('实际付款金额输入有误，请重新输入')}
          ], // 实际付款金额
        }
      },
    },
    created () {
      //this.queryUserRecordList();
    },
    methods: {
      handleTableChange(pagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.queryUserRecordList();
      },
      add () {
        this.edit({});
      },
      edit (record) { 
        this.model = Object.assign({}, record);
        this.activeKey = '1';
        this.visible = true;
        this.queryUserByKeyId(record);
      },
      queryUserByKeyId(record) {  //缴费前查询
        let params = {}
        params.id = record.id
        putAction(this.url.userByKeyId, params).then((res) => {
          if(res.success){
            this.userByKeyId = res.result;
          }
        })
      },
      queryUserRecordList() {  //缴费记录查询
        let params = {}
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        params.meterId = this.model.meterId;
        params.userAccountPayType = 1;
        getAction(this.url.UserRecordList, params).then((res) => {
          if(res.success){
            this.data = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      handleOk(){
      },
      recharge() {
        const that = this;
          that.$refs.form.validate(valid => {
          if (valid) {
            let str = ''
            if (that.thebillingtype==1) {
              str = that.$t('请核对充值金额:{amount}元?', { amount: that.form.userTotalPayNum });
            }else{
              str = that.$t('请核对实际付款金额:{amount}元?', { amount: that.form.userRealPay });
            }
            that.$confirm({
              title: that.$t('确认缴费?'),
              content: h => <div style="color:red;">{str}</div>,
              onOk() {
                that.submitForm();
              },
              onCancel() {
              },
              class: 'test',
            });
          } else {
            return false;
          }
        });
      },
      submitForm () {
        const that = this;
        let formData = Object.assign({},this.userByKeyId);
        if (this.form.buyWaterCount) {
          formData.buyWaterCount = this.form.buyWaterCount
        } if (this.form.buyWaterMoney) {
          formData.buyWaterMoney = this.form.buyWaterMoney
        } if (this.form.userRealPay) {
          formData.userRealPay = this.form.userRealPay
        } if (this.form.userReturn) {
          formData.userReturn = this.form.userReturn
        } if (this.form.userTotalPayNum) {
          formData.userTotalPayNum = this.form.userTotalPayNum
        } if (this.form.remark) {
          formData.remark = this.form.remark
        }
        formData.payType = this.form.payType
        formData.payWay = this.form .payWay
        formData.userKeyId = this.model.id
        formData.userId = this.model.userId
        formData.meterId = this.model.meterId
        console.log("缴费提交数据",formData)
        putAction(this.url.doPayTask,formData).then((res)=>{
          if(res.success&&res.code == 0){
            that.$message.success(res.message);
            setTimeout(() => {
              that.close();
              that.confirmPrint();
              that.$emit('ok');
              
            },400)
          }else{
            that.$message.error(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })
      },
      confirmPrint() {
        let that = this
        this.$confirm({
          title: this.$t('立即打印票据吗?'),
          onOk() {
            that.showModal()
            console.log('OK');
          },
          onCancel() {
            console.log('Cancel');
          },
          class: 'test',
        });
      },
      showModal() {
        this.$refs.printPayNoteModal.edit(this.userByKeyId)
      },
      userTotalPayNum() {   //充值金额
        if(parseFloat(this.form.userTotalPayNum)==0){
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('充值金额不能为0，请重新输入！')),
            ]),
            onOk() {},
          });
          this.form.userTotalPayNum="";
          this.form.buyWaterMoney="";
        } 
        if (parseFloat(this.form.userTotalPayNum) > parseFloat(this.userByKeyId.maxBuyOnce)) {
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('充值金额超过用户单次购买最大金额{max},请重新输入!', { max: this.userByKeyId.maxBuyOnce })),
            ]),
            onOk() {},
          });
          this.form.userTotalPayNum="";
          this.form.buyWaterMoney="";
        }else if ((parseFloat(this.form.userTotalPayNum)+parseFloat(this.userByKeyId.userAccountNum)) > parseFloat(this.userByKeyId.maxHording)) {
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('充值余额超过用户囤积金额{max},请重新输入!', { max: this.userByKeyId.maxHording })),
            ]),
            onOk() {},
          });
          this.form.userTotalPayNum="";
          this.form.buyWaterMoney="";
        } else {
          this.form.buyWaterMoney= this.form.userTotalPayNum;    // 充值金额的值给应收金额
          this.$set(this.form,'tradingTonnage',(this.form.userTotalPayNum / this.userByKeyId.userPriceTotal).toFixed(2));// 交易吨数
        }
      },
      buyWaterCount(){  //交易吨数
        if (this.form.buyWaterMoney) {
          this.form.buyWaterMoney=''
        }
        this.$refs.form.validateField('buyWaterCount', (valid) => {
          if (!valid) {
            if (this.form.userRealPay> this.form.buyWaterMoney) {
              this.form.userRealPay='';
              this.form.userReturn='';
            } 
            if(parseInt(this.form.buyWaterCount)==0){
                const h = this.$createElement;
                this.$info({
                  title: this.$t('信息'),
                  content: h('div', {}, [
                    h('p', this.$t('交易吨数不能为0，请重新输入！')),
                  ]),
                  onOk() {},
                });
                this.form.buyWaterCount="";
                this.form.buyWaterMoney="";
              }else if (parseFloat(this.form.buyWaterCount*this.userByKeyId.userPriceTotal) > parseFloat(this.userByKeyId.maxBuyOnce)) {
                const h = this.$createElement;
                this.$info({
                  title: this.$t('信息'),
                  content: h('div', {}, [
                    h('p', this.$t('交易金额超过用户单次购买最大金额{max},请重新输入!', { max: this.userByKeyId.maxBuyOnce })),
                  ]),
                  onOk() {},
                });
                  this.form.buyWaterCount="";
                  this.form.buyWaterMoney="";
              }else if (parseFloat(this.form.buyWaterCount*this.userByKeyId.userPriceTotal) > parseFloat(this.userByKeyId.maxHording)) {
                const h = this.$createElement;
                this.$info({
                  title: this.$t('信息'),
                  content: h('div', {}, [
                    h('p', this.$t('交易余额超过用户最大囤积值{max},请重新输入!', { max: this.userByKeyId.maxHording })),
                  ]),
                  onOk() {},
                });
                  this.form.buyWaterCount="";
                  this.form.buyWaterMoney="";
              } else {
                this.form.buyWaterMoney = parseFloat(this.form.buyWaterCount*this.userByKeyId.userPriceTotal).toFixed(2)    //应收金额的值*单价
                this.form.userRealPay = this.form.buyWaterMoney
              }
              } else {
                console.log('error submit!!');
                return false;
              }
        });
      },
      userRealPay(e){   //实际付款
        if (this.form.userRealPay!=''&&this.form.userRealPay!=undefined) {
          if (parseFloat(e.target.value) >= this.form.buyWaterMoney) {
            this.form.userReturn = parseFloat(e.target.value-this.form.buyWaterMoney).toFixed(2);
          } else{
            const h = this.$createElement;
            this.$info({
              title: this.$t('信息'),
              content: h('div', {}, [
                h('p', this.$t('实际付款金额小于应收金额，请重新输入实际付款！')),
              ]),
              onOk() {},
            });
            this.form.userRealPay="";
            this.form.userReturn="";
          }
        }
      },
      handleChange(row) {   //计费类型点击事件
        this.$nextTick(() => {
          if (this.$refs.form !==undefined) {
            this.$refs.form.clearValidate()
          }
        })
        this.thebillingtype = row.target.value,
        this.form.buyWaterCount='',
        this.form.buyWaterMoney='',
        this.form.remark='',
        this.form.userRealPay='',
        this.form.userReturn='',
        this.form.userTotalPayNum=''
      },
      amountofmoney(value){  // 金额按钮点击事件
        this.form.userTotalPayNum = value,
        this.form.buyWaterMoney = value,
        this.$refs.form.validate();
        this.userTotalPayNum();
      },
      Capacity(value) {    //交易吨数按钮点击
        this.form.buyWaterCount = value;
        this.$refs.form.validateField('buyWaterCount', (valid) => {
          if (!valid) {
            if (this.form.userRealPay> this.form.buyWaterMoney) {
            this.form.userRealPay='';
            this.form.userReturn='';
            }
            this.form.buyWaterMoney = value*this.userByKeyId.userPriceTotal;
            this.buyWaterCount();
          } else {
            console.log('error submit!!');
            return false;
          }
        }); 
      },
      shut(){    //关闭按钮
        this.thebillingtype = 2
        this.activeKey = '1';
        this.form.payType = 2;
        this.form.payWay = 1;
        this.$refs.form.resetFields();
        this.visible = false;
      },
      Refresh() {
        this.queryUserByKeyId(this.model)
      },
      changeTab(e) {
        if (e==2) {
          this.queryUserRecordList();
        }
      },
      close () {
        this.$emit('close');
        this.shut();
        this.visible = false;
      },
      handleCancel () {
        this.close();
      },
    }
  }
</script>

<style scoped>
.ant-form-item >>> .ant-select{
  width: 100%;
}
.ant-form /deep/ .ant-form-item-with-help{
  margin-bottom: 2px;
}
.span {
   margin: 8px;
}
.background{
  background-color:rgb(238,238,238)
}
.form-item{
  margin-bottom: 0px;
}
.detail-list >>> .content{
  line-height: normal;
}
.form-contain{
    height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;
}
.form-contain >>> .ant-divider-inner-text{
    color: rgba(24,144,255,0.85);
    font-size: 16px;
}
.label >>> .content{
  color:red;
}
</style>